import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
var TransformermaintainanceComponent = /** @class */ (function () {
    function TransformermaintainanceComponent(fb, transMngSer, dialogRef, tostr, formdata) {
        this.fb = fb;
        this.transMngSer = transMngSer;
        this.dialogRef = dialogRef;
        this.tostr = tostr;
        this.formdata = formdata;
        this.siteName = [];
        this.inputs = Array(5).fill(null);
        this.action = "add";
        this.selectedOptions = [];
        this.loginUserData = JSON.parse(localStorage.getItem("userData"));
        this.alertsData = ["Low Oil Level", "High Oil Temperature", "High Winding Temperature", "Critiacl Load"];
        this.selectedValues = [];
        this.dropdownOpen = false; // State for dropdown visibility
    }
    TransformermaintainanceComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.formGroup = this.fb.group({
                            sitename: new FormControl(null, [Validators.required]),
                            transformerid: new FormControl(''),
                            selectedOptions: [[]],
                            date: new FormControl(null, [Validators.required]),
                            maintainancetype: new FormControl(),
                            engineername: new FormControl(null, [Validators.required]),
                            resource: new FormControl(null, [Validators.required]),
                            downtime: new FormControl(null, [Validators.required]),
                            estimatedcost: new FormControl(null, [Validators.required]),
                            notes: new FormControl(null),
                        });
                        this.formGroup.get('maintainancetype').setValue("Predictive");
                        _a = this;
                        return [4 /*yield*/, this.getDdlData()];
                    case 1:
                        _a.siteName = _b.sent();
                        this.selectedSite = this.siteName[0];
                        this.sitemanagers = this.siteName.map(function (site) { return site.sitemanager; });
                        this.getMaintenanceParameters();
                        if (typeof this.formdata == 'object' && !Array.isArray(this.formdata)) {
                            console.log("form data", this.formdata);
                            this.action = "edit";
                            this.patchFormData(this.formdata);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TransformermaintainanceComponent.prototype.getTransformerID = function (sitename) {
        this.formGroup.controls['transformerid'].setValue(sitename.serialnumber);
    };
    TransformermaintainanceComponent.prototype.getDdlData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.transMngSer.getTransformerData(JSON.parse(localStorage.getItem('userData')).roleid, JSON.parse(localStorage.getItem('userData')).userid, 'x``z').toPromise().then(function (response) {
                if (response.data.length > 0) {
                    resolve(response.data);
                }
                resolve([]);
            });
        });
    };
    TransformermaintainanceComponent.prototype.getMaintenanceParameters = function () {
        var _this = this;
        this.transMngSer.getMaintenanceParameters().toPromise().then(function (response) {
            if (response.data.length > 0) {
                _this.options = response.data.map(function (val) { return val.parameters; });
                console.log(_this.options);
            }
        });
    };
    TransformermaintainanceComponent.prototype.patchFormData = function (valuesObject) {
        var _this = this;
        this.formGroup.patchValue({
            sitename: valuesObject.sitename,
            transformerid: valuesObject.transformerid,
            selectedOptions: valuesObject.selectedOptions.split(',').map(function (option) { return option.trim(); }),
            date: new Date(valuesObject.date),
            maintainancetype: valuesObject.maintainancetype,
            engineername: valuesObject.engineername,
            resource: valuesObject.resource,
            downtime: valuesObject.downtime,
            estimatedcost: valuesObject.estimatedcost,
            notes: valuesObject.notes,
        });
        Object.keys(this.formGroup.controls).forEach(function (field) {
            var control = _this.formGroup.get(field);
            if (control) {
                control.disable();
            }
        });
    };
    TransformermaintainanceComponent.prototype.editData = function () {
        var _this = this;
        Object.keys(this.formGroup.controls).forEach(function (field) {
            var control = _this.formGroup.get(field);
            if (control) {
                control.enable();
            }
        });
    };
    TransformermaintainanceComponent.prototype.submit = function (data) {
        var _this = this;
        var maintenanceData = data.value;
        maintenanceData.login_user_id = this.loginUserData.userid;
        maintenanceData.selectedOptions = maintenanceData.selectedOptions.join(', ');
        maintenanceData.action = this.action;
        var msg = "Plan Created";
        if (this.action == "edit") {
            maintenanceData.id = this.formdata['id'];
            msg = "Plan Updated";
        }
        console.log("MaintainanceData", maintenanceData);
        this.transMngSer.saveMaintaianceData(maintenanceData).toPromise().then(function (response) {
            if (response.code == 1) {
                _this.tostr.success(msg);
                _this.dialogRef.close();
            }
        });
    };
    return TransformermaintainanceComponent;
}());
export { TransformermaintainanceComponent };
